import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-saved-images',
  templateUrl: './saved-images.component.html',
  styleUrls: ['./saved-images.component.css']
})
export class SavedImagesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
